<template>
  <v-app-bar class="top-strip-box-shadow" color="white" height="76" fixed flat>
    <v-row align="center" no-gutters>
      <v-col cols="3" sm="3" md="3" lg="2">
        <v-row no-gutters>
          <v-col class="d-flex justify-space-around">
            <router-link
              v-if="authorized"
              :to="{
                name: 'account',
                hash: '#profile',
                params: { view: 'My Profile' },
              }"
              >Account</router-link
            >
            <LoginButton v-else />
            <router-link
              v-if="authorized && includeLoyalty && (hasClubs || hasPoints)"
              :to="{ name: 'account', hash: '#rewards' }"
              class="d-flex align-center"
            >
              <Icon
                name="crownrewards"
                color="var(--v-secondary-base)"
                :style="{ height: '20px', width: '20px' }"
              ></Icon>
              <span style="color: var(--v-secondary-base); margin-left: 5px">
                Rewards
              </span>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" sm="6" md="6" lg="8">
        <v-row no-gutters>
          <v-col class="align-center d-flex justify-center">
            <StorefrontImage size="xs" />
            <div class="pl-5 font-weight-semibold">
              {{ wait(storeInfo, "name") }}
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" sm="3" md="3" lg="2">
        <v-row align="center" no-gutters>
          <v-col class="align-center d-flex justify-center">
            <router-link
              class="d-sm-none d-md-inline mr-8 e2e-topstrip-about"
              :to="{ name: 'home' }"
              >HOME</router-link
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import LoginButton from "@/components/Auth/Buttons/Login.vue";
import Icon from "@/components/UI/Icon.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";
import { wait } from "@/util.js";

export default {
  name: "AboutTopStrip",
  components: { Icon, LoginButton, StorefrontImage },
  computed: {
    ...mapGetters("auth", { authorized: "isAuthenticated" }),
    ...mapGetters("store", { hasPoints: "hasPoints", hasClubs: "hasClubs" }),
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  data() {
    return {
      includeLoyalty:
        process.env.VUE_APP_INCLUDE_LOYALTY.toLowerCase() === "true",
    };
  },
  methods: { wait },
};
</script>

<style scoped>
.top-strip-box-shadow {
  box-shadow: inset 0 -1px 0 0 #dadada;
}
</style>
